import { render } from "./MultipodsFile.vue?vue&type=template&id=6f22da69&scoped=true"
import script from "./MultipodsFile.vue?vue&type=script&lang=js"
export * from "./MultipodsFile.vue?vue&type=script&lang=js"

import "./MultipodsFile.vue?vue&type=style&index=0&id=6f22da69&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f22da69"]])

export default __exports__